/** Libellés FR pour statuts admin. */

export const PRODUCT_STATUS: Record<string, { label: string; tone: string }> = {
  PUBLISHED: { label: 'Publié', tone: 'published' },
  DRAFT: { label: 'Brouillon', tone: 'draft' },
  ARCHIVED: { label: 'Archivé', tone: 'archived' },
}

export const ORDER_STATUS: Record<string, { label: string; tone: string }> = {
  PENDING: { label: 'En attente', tone: 'warn' },
  CONFIRMED: { label: 'Confirmée', tone: 'ok' },
  PREPARING: { label: 'En préparation', tone: 'warn' },
  SHIPPED: { label: 'Expédiée', tone: 'neutral' },
  OUT_FOR_DELIVERY: { label: 'En livraison', tone: 'warn' },
  DELIVERED: { label: 'Livrée', tone: 'ok' },
  DELIVERY_INCIDENT: { label: 'Incident', tone: 'bad' },
  CANCELLED: { label: 'Annulée', tone: 'bad' },
}

/** Flux nominal pour avancer une commande. */
export const ORDER_FLOW = [
  'PENDING',
  'CONFIRMED',
  'PREPARING',
  'SHIPPED',
  'OUT_FOR_DELIVERY',
  'DELIVERED',
] as const

export const PAYMENT_STATUS: Record<string, { label: string; tone: string }> = {
  UNPAID: { label: 'Impayée', tone: 'warn' },
  PARTIALLY_PAID: { label: 'Partiel', tone: 'warn' },
  PAID: { label: 'Payée', tone: 'ok' },
  PARTIALLY_REFUNDED: { label: 'Remb. partiel', tone: 'warn' },
  REFUNDED: { label: 'Remboursée', tone: 'neutral' },
}

export const REVIEW_STATUS: Record<string, { label: string; tone: string }> = {
  PENDING: { label: 'En attente', tone: 'warn' },
  NEEDS_INFO: { label: 'Précision', tone: 'warn' },
  PUBLISHED: { label: 'Publié', tone: 'ok' },
  REJECTED: { label: 'Refusé', tone: 'bad' },
}

export const RETURN_STATUS: Record<string, { label: string; tone: string }> = {
  OPEN: { label: 'Ouvert', tone: 'warn' },
  ACCEPTED: { label: 'Accepté', tone: 'ok' },
  REFUSED: { label: 'Refusé', tone: 'bad' },
  REFUNDED: { label: 'Remboursé', tone: 'ok' },
  DISPUTED: { label: 'Litige', tone: 'bad' },
}

export const STAFF_ROLES = ['ADMIN', 'SALES', 'WAREHOUSE', 'COURIER', 'FINANCE'] as const

export function fmtDate(iso: string | Date | null | undefined) {
  if (!iso) return '—'
  const d = typeof iso === 'string' ? new Date(iso) : iso
  return d.toLocaleDateString('fr-CD', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function fmtDateTime(iso: string | Date | null | undefined) {
  if (!iso) return '—'
  const d = typeof iso === 'string' ? new Date(iso) : iso
  return d.toLocaleString('fr-CD', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function dollarsFromCents(cents: number) {
  return (cents / 100).toFixed(2)
}

export function centsFromDollars(raw: string) {
  const n = Number.parseFloat(raw.replace(',', '.'))
  if (Number.isNaN(n) || n < 0) return 0
  return Math.round(n * 100)
}
